import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
    display: flex;
    flex: 1 1 0%;
    justify-content: center;
    flex-flow: row wrap;
    margin-bottom: 15px;
    margin-top: 30px;
    align-items: baseline;
    border-top: 1px solid lightgray;
    padding-top: 10px;

`;

const AuthFormFooter = ({style, children, ...rest}) => (
    <StyledDiv style={style} {...rest}>
        { children }
    </StyledDiv>
)



export default AuthFormFooter;


// WEBPACK FOOTER //
// ./src/js/components/Form/AuthFormFooter.jsx